<template>
    <div class="media-details" ref="media-details">
        <div class="media-details__close" v-on:click="$emit('close')">
            <svg class="media-details__close__icon" width="13px" height="11px" viewBox="0 0 13 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="design_Mapa_nośników" transform="translate(-696.000000, -312.000000)" fill="#fff">
                        <g id="google_maps_search" transform="translate(310.000000, 293.000000)">
                            <g id="Group-2" transform="translate(373.000000, 0.000000)">
                                <g id="San-Mateo-CA,-United-States-Copy" transform="translate(13.500000, 16.000000)">
                                    <g id="Icons/add_cross_ico" transform="translate(0.000000, 3.000000)">
                                        <rect id="Rectangle" x="4.5" y="0" width="2" height="11" rx="1"></rect>
                                        <rect id="Rectangle-Copy" transform="translate(6.000000, 5.500000) rotate(90.000000) translate(-6.000000, -5.500000) " x="5" y="-0.5" width="2" height="12" rx="1"></rect>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
        <div class="media-details__img" v-if="current.img">
            <img v-bind:src="current.img" alt="">
            <Loader class="loader"></Loader>
        </div>

        <div class="media-details__content">
            <p class="media-details__title">{{ current.title }}</p>
            <p class="media-details__address"><img src="/content/themes/warexpo/assets/images/map/icon-marker.png" alt="">{{ current.address }}</p>
            <small class="media-details__coords">{{ dms }}</small>
            <div class="media-details__info media-details__info--1"><img src="/content/themes/warexpo/assets/images/map/icon-user.png" alt="">{{ formattedCountMedia }}</div>
<!--            <div class="media-details__info media-details__info&#45;&#45;2"><img src="/content/themes/warexpo/assets/images/map/icon-user.png" alt="">{{ formattedReceivers }}</div>-->
        </div>
        <div class="media-details__cta-wrapper">
            <a :href="current.url" target="_blank" class="media-details__cta">{{ seeCarrierLabel }}
                <svg width="8px" height="10px" viewBox="0 0 8 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="design_Mapa_nośników" transform="translate(-1016.000000, -829.000000)" fill="#FDB913">
                            <g id="Group-4" transform="translate(0.000000, 352.000000)">
                                <g id="Group-17" transform="translate(892.000000, 155.000000)">
                                    <g id="Group-6" transform="translate(22.000000, 318.000000)">
                                        <polygon id="arrow_right" transform="translate(106.000000, 9.000000) rotate(90.000000) translate(-106.000000, -9.000000) " points="106 5.5 101 12.5 111 12.5"></polygon>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </a>
            <a :href="navigateUrl" target="_blank" class="media-details__cta">{{ navigateLabel }}
                <svg width="17px" height="16px" viewBox="0 0 17 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="design_Mapa_nośników" transform="translate(-1122.000000, -826.000000)" fill="#FDB913">
                            <g id="Group-4" transform="translate(0.000000, 352.000000)">
                                <g id="Group-17" transform="translate(892.000000, 155.000000)">
                                    <g id="Group-5" transform="translate(170.000000, 318.002500)">
                                        <g id="ic_directions_black_24px" transform="translate(60.507500, 0.997500)">
                                            <path d="M15.7659415,7.43585896 L8.56414104,0.234058515 C8.25206302,-0.0780195049 7.74793698,-0.0780195049 7.43585896,0.234058515 L0.234058515,7.43585896 C-0.0780195049,7.74793698 -0.0780195049,8.25206302 0.234058515,8.56414104 L7.43585896,15.7659415 C7.74793698,16.0780195 8.25206302,16.0780195 8.56414104,15.7659415 L15.7659415,8.56414104 C16.0780195,8.26006502 16.0780195,7.75593898 15.7659415,7.43585896 L15.7659415,7.43585896 Z M9.5963991,10.0045011 L9.5963991,8.004001 L6.3955989,8.004001 L6.3955989,10.4046012 L4.7951988,10.4046012 L4.7951988,7.20380095 C4.7951988,6.76369092 5.15528882,6.4036009 5.59539885,6.4036009 L9.5963991,6.4036009 L9.5963991,4.40310078 L12.3970993,7.20380095 L9.5963991,10.0045011 L9.5963991,10.0045011 Z" id="Shape"></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            </a>
        </div>
    </div>
</template>

<script>
    import {polishPlurals} from 'polish-plurals';
    import {convertDMS} from "../../shared/geo";
    import Loader from "../../shared/components/Loader";

    export default {
        components: {
          Loader,
        },
        name: "MediaDetails",
        props: ['current'],

        computed: {
            seeCarrierLabel() {
                return this.backendData.see_carrier;
            },

            navigateLabel() {
                return this.backendData.navigate;
            },

            dms() {
                return convertDMS(this.current.lat, this.current.lng);
            },

            formattedCountMedia() {
                return `${this.current.countMedia} ${polishPlurals("nośnik", "nośniki", "nośników", this.current.countMedia)}`;
            },

            navigateUrl() {
                return `https://www.google.com/maps/dir/?api=1&destination=${this.current.lat},${this.current.lng}`;
            },

            backendData() {
                return warexpoMediaMap;
            }

        },
}
</script>

<style scoped lang="scss">
.media-details {
    font-family: "Source Sans Pro", sans-serif;
    width: 100%;
    height: 100%;
    background: #fff;
    position: relative;
    //top: -30px;

    &__img {
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            position: relative;
            z-index: 2;
            width: 100%;
            height: 130px;
            object-fit: cover;
        }
    }

    &__content {
        padding: 12px 18px 25px;
        //height: 210px;
    }

    &__title {
        color: #151F2F;
        font-size: 20px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 25px;
    }

    &__address {
        position: relative;
        margin: 0;
        padding-left: 16px;
        line-height: 19px;
        color: #5C5F64;
        font-size: 15px;
        letter-spacing: 0;

        img {
            position: absolute;
            left: 0;
            top: 3px;
        }
    }

    &__coords {
        opacity: 0.5;
        color: #5C5F64;
        font-size: 12px;
        letter-spacing: 0;
        line-height: 15px;
        padding-left: 17px;
        margin-top: 5px;
        display: block;
    }

    &__info {
        color: #5C5F64;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 18px;
        img {
            margin-right: 6px;
        }

        &--1 {
            margin-top: 19px;
        }
    }

    &__cta-wrapper {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-top: 1px solid rgba(151, 151, 151, 0.21);
    }

    &__cta {
        color: #002B60;
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 17px;
        text-align: center;
        text-transform: uppercase;

        svg {
            margin-left: 8px;
        }
    }

    &__close {
        position: absolute;
        top: 0;
        right: 0;
        width: 36px;
        height: 36px;
        background: #0e2b60;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 3;

        &__icon {
            transform: rotate(45deg);
        }
    }
}

.loader {
    position: absolute;
    z-index: 1;
}
</style>
